// Arquivo: src/pages/Excecoes/ExcecaoForm.js

import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import AlertComponent from "../../components/AlertComponent";
import Loading from "../../components/Loading";
import { Context } from "../../Reducers/Store";


export default function ExcecaoForm() {
  const navigate = useNavigate();
  const [state] = useContext(Context);

  const [formData, setFormData] = useState({
    controleUsuarioId: "",
    dataExcecao: "",
    horaInicio: "",
    horaFim: "",
    motivo: "",
  });
  const [loginsSQL, setLoginsSQL] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(true);

  // Carrega logins SQL disponíveis
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API}/controle-usuarios?ativo=true&pageSize=1000`)
      .then((res) => {
        const data = res.data?.data?.items || res.data?.data || [];
        setLoginsSQL(Array.isArray(data) ? data : []);
      })
      .catch((err) => console.error(err))
      .finally(() => setLoadingData(false));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.motivo || formData.motivo.trim().length < 10) {
      AlertComponent("Atenção", "O motivo deve ter no mínimo 10 caracteres.", { icon: "warning" });
      return;
    }

    setLoading(true);

    try {
      const payload = {
        ...formData,
        controleUsuarioId: parseInt(formData.controleUsuarioId),
        criadoPor: state.profile.name || state.profile.email || 'Web'
      };

      await axios.post(`${process.env.REACT_APP_API}/excecoes`, payload);
      AlertComponent("Sucesso", "Exceção criada com sucesso!", { icon: "success" });
      navigate("/excecoes");
    } catch (error) {
      console.error("Erro ao salvar:", error);
      AlertComponent("Erro", error?.response?.data?.message ?? "Erro ao salvar", { icon: "error" });
    } finally {
      setLoading(false);
    }
  };

  if (loadingData) return <Loading />;

  return (
    <div className="w-full">
      <div className="mb-8">
        <h1 className="text-2xl font-semibold text-slate-800">Nova Exceção</h1>
        <p className="text-sm text-slate-500">
          Crie uma permissão temporária fora do horário de bloqueio
        </p>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="bg-white p-8 rounded-xl shadow border mb-6">
          <h2 className="text-lg font-medium text-gray-800 mb-6">Dados da Exceção</h2>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Login SQL *
              </label>
              <select
                name="controleUsuarioId"
                value={formData.controleUsuarioId}
                onChange={handleChange}
                className="w-full p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-slate-300"
                required
                disabled={loading}
              >
                <option value="">Selecione...</option>
                {loginsSQL.map((login) => (
                  <option key={login.id} value={login.id}>
                    {login.loginName}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Data *
              </label>
              <input
                type="date"
                name="dataExcecao"
                value={formData.dataExcecao}
                onChange={handleChange}
                className="w-full p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-slate-300"
                required
                disabled={loading}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Hora Início *
              </label>
              <input
                type="time"
                name="horaInicio"
                value={formData.horaInicio}
                onChange={handleChange}
                className="w-full p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-slate-300"
                required
                disabled={loading}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Hora Fim *
              </label>
              <input
                type="time"
                name="horaFim"
                value={formData.horaFim}
                onChange={handleChange}
                className="w-full p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-slate-300"
                required
                disabled={loading}
              />
            </div>

            <div className="md:col-span-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Motivo *
              </label>
              <textarea
                name="motivo"
                value={formData.motivo}
                onChange={handleChange}
                rows={3}
                className="w-full p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-slate-300 resize-none"
                placeholder="Descreva o motivo da exceção (mínimo 10 caracteres)"
                required
                minLength={10}
                disabled={loading}
              />
              <p className="text-xs text-gray-400 mt-1">
                {formData.motivo?.length || 0}/10 caracteres mínimos
              </p>
            </div>
          </div>
        </div>

        <div className="flex justify-end gap-3 border-t pt-6">
          <button
            type="button"
            onClick={() => navigate("/excecoes")}
            className="px-5 py-2 rounded-md border hover:bg-gray-50 disabled:opacity-50"
            disabled={loading}
          >
            Cancelar
          </button>

          <button
            type="submit"
            className="px-6 py-2 rounded-md bg-slate-900 text-white hover:bg-slate-800 disabled:opacity-50"
            disabled={loading}
          >
            {loading ? "Salvando..." : "Criar exceção"}
          </button>
        </div>
      </form>
    </div>
  );
}